import { SchemaProps } from '@evertel/types'

const normalize = (schema: SchemaProps): SchemaProps => {

    if (!schema) {
        console.error('SCHEMA-PARSER/normalize(): missing schema')
        return {layouts: {full: []}}
    }

    const normalizedViews = { full: [] }

    //console.log(schema)
    const entries = Object.entries(schema.layouts) as Array<['full', SchemaProps['layouts']['full']]>
    for (const [layout, fields] of entries) {

        // @ts-ignore
        normalizedViews[layout] = fields?.map(({type, ...props}) => {

            // Fields
            if (type?.startsWith('#')) {
                const key = type.substring(1)

                const normalized = normalize(
                    {
                        layouts: {
                            [layout]: [
                                {
                                    ...props,
                                    ...schema.fields[key]
                                }
                            ]
                        },
                        fields: schema.fields,
                        internalSchemas: schema.internalSchemas
                    }
                )

                type = key

                props = {
                    ...props,
                    ...normalized.layouts[layout][0]
                }
            }

            // Internal Schemas/List/Sub-Form
            if (type?.startsWith('&')) {
                const key = type.substring(1)

                const normalized = normalize(
                    {
                        layouts: {
                            ...schema.internalSchemas[key].layouts
                        },
                        fields: {
                            ...schema.fields,
                            ...schema.internalSchemas[key].fields
                        },
                        internalSchemas: {
                            ...schema.internalSchemas[key].internalSchemas
                        }
                    }
                )

                type = key

                // NOTE: 'type' is intentionally included here — it overrides the destructured
                // 'type' variable in the final `{ type, ...props }` spread below, so the item
                // renders as a list. The rest-type of 'props' omits 'type', hence the assertion.
                props = {
                    ...props,
                    internalSchemaId: key,
                    id: (schema.internalSchemas[key]) ? key : props?.id, // props.id handles legacy schema bad data
                    overrideId: props?.id, // backwards compatibility for legacy schema bad data
                    type: 'list',
                    items: normalized.layouts[layout]
                } as typeof props
            }

            // Row items
            if (type === 'form' || type === 'container' || type === 'row') {
                const normalized = normalize(
                    {
                        layouts: {
                            [layout]: props.items
                        },
                        fields: schema.fields,
                        internalSchemas: schema.internalSchemas
                    }
                )

                props = {
                    ...props,
                    items: normalized.layouts[layout]
                }
            }

            // legacy formatted List/Sub-Form/Internal Schema item
            if (type === 'list' && props?.item) {
                const normalized = normalize(
                    {
                        layouts: {
                            [layout]: [props.item]
                        },
                        fields: schema.fields,
                        internalSchemas: schema.internalSchemas
                    }
                )

                props = {
                    ...props,
                    item: normalized.layouts[layout][0]
                }
            }

            // Polymorphic options
            if (type === 'polymorphic' && props?.options) {
                const normalized = props.options?.map((option) => {
                    const normalized = normalize(
                        {
                            layouts: {
                                [layout]: [option.item]
                            },
                            fields: schema.fields,
                            internalSchemas: schema.internalSchemas
                        }
                    )

                    return {
                        ...option,
                        item: normalized.layouts[layout][0]
                    }
                })

                props = {
                    ...props,
                    options: normalized
                }
            }

            return {
                type: type,
                ...props
            }
        })
    }

    return {
        layouts: normalizedViews
    }
}

export {
    normalize
}
